var map = {
	"./ageas.png": "4c79",
	"./default.png": "7851",
	"./logo-fidelidade.png": "3365",
	"./logo-horizontal-NSeguros.png": "84f3",
	"./logo_lusitania-segurosjuntos.png": "7d99",
	"./oc.png": "68a1",
	"./sd.png": "76ff",
	"./una-seguros.png": "6124",
	"./victoria.png": "4b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "140d";